<h1>Verification Codes</h1>

<div class="card">
  <div class="card-header">Codes</div>
  <div class="card-block">
    <div class="table-responsive">
      <div class="loading-cont" *ngIf="loading"><div class="loading-spinner"></div></div>
      <p class="no-items-found" *ngIf="!loading && 0 === items.length">No items found.</p>

      <table class="table table-hover" *ngIf="!loading && 0 < items.length">
        <thead>
          <tr>
            <th>
              <span class="col-name">Email</span>
            </th>
            <th>
              <span class="col-name">Code</span>
            </th>
            <th>
              <span class="col-name">Expires At</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items; let i = index">
            <td>{{ item.email }}</td>
            <td>{{ item.code }}</td>
            <td>{{ item.expiryDate | dateFormat }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/verification-codes/verification-codes.component.html